import { OrganizationId } from '@/rule/domain/OrganizationId.ts';

type AllRulesScope = { kind: 'ALL' };
type DefaultRulesScope = { kind: 'DEFAULT' };
type OrganizationRulesScope = { kind: 'ORGANIZATION'; organizationId: OrganizationId };

export type RulesScope = AllRulesScope | DefaultRulesScope | OrganizationRulesScope;

export const RulesScope = {
  all: (): RulesScope => ({ kind: 'ALL' }),
  default: (): RulesScope => ({ kind: 'DEFAULT' }),
  organization: (organizationId: OrganizationId | string): RulesScope => ({
    kind: 'ORGANIZATION',
    organizationId: OrganizationId.of(organizationId),
  }),
};
